/** Do not edit directly **/
/**
* This function require the following tokens:
*
*   // DISABLED STATE
*   sy-{$component}-background-color-disabled-{$color}
*   sy-{$component}-color-disabled-{$color}
*   sy-{$component}-border-color-disabled-{$color}
*
*   // HOVER and FOCUS STATE
*   sy-{$component}-background-color-hover-{$color}
*   sy-{$component}-border-color-hover-{$color}
*
*   // ACTIVE STATE
*   sy-{$component}-background-color-active-{$color}
*   sy-{$component}-border-color-active-{$color}
*
*   // FOCUS VISIBLE STATE
*   sy-{$component}-border-color-focus-visible
*/
/**
* DEPRECATED
*/
/**
* DEPRECATED
*/
/**
* DEPRECATED
*/
/** Do not edit directly **/
/**
 * @prop --sy-button-width: Button width.
 * @prop --sy-button-height: Button height.
 * @prop --sy-button-padding: Button padding.
 * @prop --sy-button-padding-small: Button padding small.
 * @prop --sy-button-padding-x: Button padding x.
 * @prop --sy-button-padding-x-small: Button padding x small.
 * @prop --sy-button-padding-y: Button padding y.
 * @prop --sy-button-padding-y-small: Button padding y small.
 * @prop --sy-button-color-primary: Primary background color.
 * @prop --sy-button-color-accent: Accent background color.
 * @prop --sy-button-color-success: Success background color.
 * @prop --sy-button-color-error: Error background color.
 * @prop --sy-button-color-basic: Button color basic.
 * @prop --sy-button-color: Button color.
 * @prop --sy-button-color-disabled-primary: Primary disabled color.
 * @prop --sy-button-color-disabled-accent: Accent disabled color.
 * @prop --sy-button-color-disabled-success: Success disabled color.
 * @prop --sy-button-color-disabled-error: Error disabled color.
 * @prop --sy-button-color-disabled-basic: Button color disabled basic.
 * @prop --sy-button-color-disabled: Button color disabled.
 * @prop --sy-button-border-width: Button border width.
 * @prop --sy-button-border-radius: Button border radius.
 * @prop --sy-button-border-color-primary: Primary border color.
 * @prop --sy-button-border-color-accent: Accent border color.
 * @prop --sy-button-border-color-success: Success border color.
 * @prop --sy-button-border-color-error: Error border color.
 * @prop --sy-button-border-color-basic: Button border color basic.
 * @prop --sy-button-border-color: Button border color.
 * @prop --sy-button-border-color-hover-primary: Primary hover border color.
 * @prop --sy-button-border-color-hover-accent: Accent hover border color.
 * @prop --sy-button-border-color-hover-success: Success hover border color.
 * @prop --sy-button-border-color-hover-error: Error hover border color.
 * @prop --sy-button-border-color-hover-basic: Button border color hover basic.
 * @prop --sy-button-border-color-hover: Button border color hover.
 * @prop --sy-button-border-color-active-primary: Primary active background color.
 * @prop --sy-button-border-color-active-accent: Accent active background color.
 * @prop --sy-button-border-color-active-success: Success active background color.
 * @prop --sy-button-border-color-active-error: Error active background color.
 * @prop --sy-button-border-color-active-basic: Button border color active basic.
 * @prop --sy-button-border-color-active: Button border color active.
 * @prop --sy-button-border-color-disabled-primary: Primary disabled border color.
 * @prop --sy-button-border-color-disabled-accent: Accent disabled border color.
 * @prop --sy-button-border-color-disabled-success: Success disabled border color.
 * @prop --sy-button-border-color-disabled-error: Error disabled border color.
 * @prop --sy-button-border-color-disabled-basic: Button border color disabled basic.
 * @prop --sy-button-border-color-disabled: Button border color disabled.
 * @prop --sy-button-border-color-focus-visible: Button border color focus visible.
 * @prop --sy-button-background-color-primary: Primary background color.
 * @prop --sy-button-background-color-accent: Accent background color.
 * @prop --sy-button-background-color-success: Success background color.
 * @prop --sy-button-background-color-error: Error background color.
 * @prop --sy-button-background-color-basic: Button background color basic.
 * @prop --sy-button-background-color: Button background color.
 * @prop --sy-button-background-color-hover-primary: Primary hover background color.
 * @prop --sy-button-background-color-hover-accent: Accent hover background color.
 * @prop --sy-button-background-color-hover-success: Success hover background color.
 * @prop --sy-button-background-color-hover-error: Error hover background color.
 * @prop --sy-button-background-color-hover-basic: Button background color hover basic.
 * @prop --sy-button-background-color-hover: Button background color hover.
 * @prop --sy-button-background-color-active-primary: Primary active background color.
 * @prop --sy-button-background-color-active-accent: Accent active background color.
 * @prop --sy-button-background-color-active-success: Success active background color.
 * @prop --sy-button-background-color-active-error: Error active background color.
 * @prop --sy-button-background-color-active-basic: Button background color active basic.
 * @prop --sy-button-background-color-active: Button background color active.
 * @prop --sy-button-background-color-disabled-primary: Primary disabled background color.
 * @prop --sy-button-background-color-disabled-accent: Accent disabled background color.
 * @prop --sy-button-background-color-disabled-success: Success disabled background color.
 * @prop --sy-button-background-color-disabled-error: Error disabled background color.
 * @prop --sy-button-background-color-disabled-basic: Button background color disabled basic.
 * @prop --sy-button-background-color-disabled: Button background color disabled.
 * @prop --sy-button-icon-size: Button icon size.
 * @prop --sy-button-icon-margin: Button icon margin.
 * @prop --sy-button-icon-color-primary: Primary icon color.
 * @prop --sy-button-icon-color-accent: Accent icon color.
 * @prop --sy-button-icon-color-success: Success icon color.
 * @prop --sy-button-icon-color-error: Error icon color.
 * @prop --sy-button-icon-color-basic: Button icon color basic.
 * @prop --sy-button-icon-color: Button icon color.
 * @prop --sy-button-loading-speed: Button loading speed.
 * @prop --sy-button-loading-color: Button loading color.
 * @prop --sy-button-font-size: Button font size.
 * @prop --sy-button-text-decoration: Button text decoration.
 * @prop --sy-button-font-family: Button font family.
 * @prop --sy-button-font-weight: Button font weight.
 * @prop --sy-button-font-style: Button font style.
 * @prop --sy-button-font-stretch: Button font stretch.
 * @prop --sy-button-letter-spacing: Button letter spacing.
 * @prop --sy-button-line-height: Button line height.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

button {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

button,
[type=button],
[type=reset],
[type=submit] {
  appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

:host {
  display: inline-flex;
  width: var(--sy-button-width, auto);
  height: var(--sy-button-height, auto);
  outline: none;
}

.sy-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: var(--sy-button-padding, var(--sy-button-padding-y, calc(var(--sy-spacer-3) - var(--sy-button-border-width, 1px))) var(--sy-button-padding-x, calc(var(--sy-spacer-4) - var(--sy-button-border-width, 1px))));
  color: var(--sy-button-color, var(--sy-foreground-medium-emphasis));
  text-align: center;
  cursor: pointer;
  user-select: none;
  background-color: var(--sy-button-background-color, var(--sy-surface-elevated));
  border-color: var(--sy-button-border-color, var(--sy-border));
  border-style: solid;
  border-width: var(--sy-button-border-width, 1px);
  border-radius: var(--sy-button-border-radius, var(--sy-border-radius-rounded));
  outline: 0;
  font-size: var(--sy-button-font-size, var(--sy-content-regular-body-font-size));
  text-decoration: var(--sy-button-text-decoration, var(--sy-content-regular-body-text-decoration));
  font-family: var(--sy-button-font-family, var(--sy-content-regular-body-font-family));
  font-weight: var(--sy-button-font-weight, var(--sy-content-regular-body-font-weight));
  font-style: var(--sy-button-font-style, var(--sy-content-regular-body-font-style));
  font-stretch: var(--sy-button-font-stretch, var(--sy-content-regular-body-font-stretch));
  letter-spacing: var(--sy-button-letter-spacing, var(--sy-content-regular-body-letter-spacing));
  line-height: var(--sy-button-line-height, 1);
  --sy-icon-color: var(--sy-button-icon-color, var(--sy-foreground-medium-emphasis));
}
.sy-btn[disabled], .sy-btn.disabled {
  color: var(--sy-button-color-disabled, var(--sy-disabled-contrast)) !important;
  cursor: not-allowed !important;
  background-color: var(--sy-button-background-color-disabled, transparent) !important;
  border-color: var(--sy-button-border-color-disabled, var(--sy-disabled)) !important;
  --sy-icon-color: var(--sy-button-color-disabled, var(--sy-disabled-contrast)) !important;
}
.sy-btn:hover, .sy-btn:focus {
  background-color: var(--sy-button-background-color-hover, var(--sy-surface-hover));
  border-color: var(--sy-button-border-color-hover, var(--sy-border));
}
.sy-btn:active, .sy-btn.active, .sy-btn[active] {
  background-color: var(--sy-button-background-color-active, var(--sy-surface-active));
  border-color: var(--sy-button-border-color-active, var(--sy-border));
}
.sy-btn:focus-visible {
  box-shadow: 0 0 0 1px var(--sy-button-border-color-focus-visible, var(--sy-accent));
}

.sy-btn-icon {
  --sy-icon-size: var(--sy-button-icon-size, 16px);
  --stroke-width: 1.5px;
}

.sy-btn-inner-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.sy-btn-icon-left .sy-btn-icon {
  margin-right: var(--sy-button-icon-margin, var(--sy-spacer-3));
}

.sy-btn-icon-right .sy-btn-icon {
  margin-left: var(--sy-button-icon-margin, var(--sy-spacer-3));
}

.sy-btn-icon-only {
  padding: var(--sy-button-padding-y, calc(var(--sy-spacer-3) - var(--sy-button-border-width, 1px)));
}

sy-progress-spinner {
  --sy-progress-spinner-indeterminate-animation-speed: var(--sy-button-loading-speed, 1s);
  --sy-progress-spinner-progress-color: var(--sy-button-loading-color, var(--sy-foreground-medium-emphasis));
}
sy-progress-spinner.icon-left {
  margin-right: var(--sy-button-icon-margin, var(--sy-spacer-3));
}
sy-progress-spinner.icon-right {
  margin-left: var(--sy-button-icon-margin, var(--sy-spacer-3));
}

.sy-btn-sm {
  padding: var(--sy-button-padding-small, var(--sy-button-padding-y-small, calc(var(--sy-spacer-2) - var(--sy-button-border-width, 1px))) var(--sy-button-padding-x-small, calc(var(--sy-spacer-3) - var(--sy-button-border-width, 1px))));
}
.sy-btn-sm.sy-btn-icon-only {
  padding: var(--sy-button-padding-y-small, calc(var(--sy-spacer-2) - var(--sy-button-border-width, 1px)));
}

.sy-btn-basic {
  color: var(--sy-button-color-basic, var(--sy-foreground-medium-emphasis));
  background-color: var(--sy-button-background-color-basic, transparent);
  border-color: var(--sy-button-border-color-basic, transparent);
  --sy-icon-color: var(--sy-button-icon-color-basic, var(--sy-foreground-medium-emphasis));
}
.sy-btn-basic[disabled], .sy-btn-basic.disabled {
  color: var(--sy-button-color-disabled-basic, var(--sy-disabled-contrast)) !important;
  cursor: not-allowed !important;
  background-color: var(--sy-button-background-color-disabled-basic, transparent) !important;
  border-color: var(--sy-button-border-color-disabled-basic, transparent) !important;
  --sy-icon-color: var(--sy-button-color-disabled-basic, var(--sy-disabled-contrast)) !important;
}
.sy-btn-basic:hover, .sy-btn-basic:focus {
  background-color: var(--sy-button-background-color-hover-basic, var(--sy-surface-hover));
  border-color: var(--sy-button-border-color-hover-basic, var(--sy-surface-hover));
}
.sy-btn-basic:active, .sy-btn-basic.active, .sy-btn-basic[active] {
  background-color: var(--sy-button-background-color-active-basic, var(--sy-surface-active));
  border-color: var(--sy-button-border-color-active-basic, var(--sy-surface-active));
}
.sy-btn-basic:focus-visible {
  box-shadow: 0 0 0 1px var(--sy-button-border-color-focus-visible, var(--sy-accent));
}

.sy-btn-primary {
  color: var(--sy-button-color-primary, var(--sy-primary-contrast));
  background-color: var(--sy-button-background-color-primary, var(--sy-primary));
  border-color: var(--sy-button-border-color-primary, var(--sy-primary));
  --sy-icon-color: var(--sy-button-icon-color-primary, var(--sy-primary-contrast));
}
.sy-btn-primary[disabled], .sy-btn-primary.disabled {
  color: var(--sy-button-color-disabled-primary, var(--sy-disabled-contrast)) !important;
  cursor: not-allowed !important;
  background-color: var(--sy-button-background-color-disabled-primary, var(--sy-disabled)) !important;
  border-color: var(--sy-button-border-color-disabled-primary, var(--sy-disabled)) !important;
  --sy-icon-color: var(--sy-button-color-disabled-primary, var(--sy-disabled-contrast)) !important;
}
.sy-btn-primary:hover, .sy-btn-primary:focus {
  background-color: var(--sy-button-background-color-hover-primary, var(--sy-primary-hover));
  border-color: var(--sy-button-border-color-hover-primary, var(--sy-primary-hover));
}
.sy-btn-primary:active, .sy-btn-primary.active, .sy-btn-primary[active] {
  background-color: var(--sy-button-background-color-active-primary, var(--sy-primary-active));
  border-color: var(--sy-button-border-color-active-primary, var(--sy-primary-active));
}
.sy-btn-primary:focus-visible {
  box-shadow: 0 0 0 1px var(--sy-button-border-color-focus-visible, var(--sy-accent));
}

.sy-btn-accent {
  color: var(--sy-button-color-accent, var(--sy-accent-contrast));
  background-color: var(--sy-button-background-color-accent, var(--sy-accent));
  border-color: var(--sy-button-border-color-accent, var(--sy-accent));
  --sy-icon-color: var(--sy-button-icon-color-accent, var(--sy-accent-contrast));
}
.sy-btn-accent[disabled], .sy-btn-accent.disabled {
  color: var(--sy-button-color-disabled-accent, var(--sy-disabled-contrast)) !important;
  cursor: not-allowed !important;
  background-color: var(--sy-button-background-color-disabled-accent, var(--sy-disabled)) !important;
  border-color: var(--sy-button-border-color-disabled-accent, var(--sy-disabled)) !important;
  --sy-icon-color: var(--sy-button-color-disabled-accent, var(--sy-disabled-contrast)) !important;
}
.sy-btn-accent:hover, .sy-btn-accent:focus {
  background-color: var(--sy-button-background-color-hover-accent, var(--sy-accent-hover));
  border-color: var(--sy-button-border-color-hover-accent, var(--sy-accent-hover));
}
.sy-btn-accent:active, .sy-btn-accent.active, .sy-btn-accent[active] {
  background-color: var(--sy-button-background-color-active-accent, var(--sy-accent-active));
  border-color: var(--sy-button-border-color-active-accent, var(--sy-accent-active));
}
.sy-btn-accent:focus-visible {
  box-shadow: 0 0 0 1px var(--sy-button-border-color-focus-visible, var(--sy-accent));
}

.sy-btn-error {
  color: var(--sy-button-color-error, var(--sy-error-contrast));
  background-color: var(--sy-button-background-color-error, var(--sy-error));
  border-color: var(--sy-button-border-color-error, var(--sy-error));
  --sy-icon-color: var(--sy-button-icon-color-error, var(--sy-error-contrast));
}
.sy-btn-error[disabled], .sy-btn-error.disabled {
  color: var(--sy-button-color-disabled-error, var(--sy-disabled-contrast)) !important;
  cursor: not-allowed !important;
  background-color: var(--sy-button-background-color-disabled-error, var(--sy-disabled)) !important;
  border-color: var(--sy-button-border-color-disabled-error, var(--sy-disabled)) !important;
  --sy-icon-color: var(--sy-button-color-disabled-error, var(--sy-disabled-contrast)) !important;
}
.sy-btn-error:hover, .sy-btn-error:focus {
  background-color: var(--sy-button-background-color-hover-error, var(--sy-error-hover));
  border-color: var(--sy-button-border-color-hover-error, var(--sy-error-hover));
}
.sy-btn-error:active, .sy-btn-error.active, .sy-btn-error[active] {
  background-color: var(--sy-button-background-color-active-error, var(--sy-error-active));
  border-color: var(--sy-button-border-color-active-error, var(--sy-error-active));
}
.sy-btn-error:focus-visible {
  box-shadow: 0 0 0 1px var(--sy-button-border-color-focus-visible, var(--sy-accent));
}

.sy-btn-success {
  color: var(--sy-button-color-success, var(--sy-success-contrast));
  background-color: var(--sy-button-background-color-success, var(--sy-success));
  border-color: var(--sy-button-border-color-success, var(--sy-success));
  --sy-icon-color: var(--sy-button-icon-color-success, var(--sy-success-contrast));
}
.sy-btn-success[disabled], .sy-btn-success.disabled {
  color: var(--sy-button-color-disabled-success, var(--sy-disabled-contrast)) !important;
  cursor: not-allowed !important;
  background-color: var(--sy-button-background-color-disabled-success, var(--sy-disabled)) !important;
  border-color: var(--sy-button-border-color-disabled-success, var(--sy-disabled)) !important;
  --sy-icon-color: var(--sy-button-color-disabled-success, var(--sy-disabled-contrast)) !important;
}
.sy-btn-success:hover, .sy-btn-success:focus {
  background-color: var(--sy-button-background-color-hover-success, var(--sy-success-hover));
  border-color: var(--sy-button-border-color-hover-success, var(--sy-success-hover));
}
.sy-btn-success:active, .sy-btn-success.active, .sy-btn-success[active] {
  background-color: var(--sy-button-background-color-active-success, var(--sy-success-active));
  border-color: var(--sy-button-border-color-active-success, var(--sy-success-active));
}
.sy-btn-success:focus-visible {
  box-shadow: 0 0 0 1px var(--sy-button-border-color-focus-visible, var(--sy-accent));
}